export function hasForskrivarkod({
    profile,
}: {
    profile: { personalPrescriptionCode?: string; groupPrescriptionCode?: string } | null;
}): boolean {
    return !!(profile?.personalPrescriptionCode || profile?.groupPrescriptionCode);
}
